import { render, staticRenderFns } from "./yuedu.vue?vue&type=template&id=45647a90&scoped=true&"
import script from "./yuedu.vue?vue&type=script&lang=js&"
export * from "./yuedu.vue?vue&type=script&lang=js&"
import style0 from "./yuedu.vue?vue&type=style&index=0&id=45647a90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45647a90",
  null
  
)

export default component.exports